/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolcardupdated2Inputs */

const en_toolcardupdated2 = /** @type {(inputs: Toolcardupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✏ updated`)
};

const pt_toolcardupdated2 = /** @type {(inputs: Toolcardupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✏ atualizado`)
};

/**
* | output |
* | --- |
* | "✏ updated" |
*
* @param {Toolcardupdated2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const toolcardupdated2 = /** @type {((inputs?: Toolcardupdated2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolcardupdated2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toolcardupdated2(inputs)
	return pt_toolcardupdated2(inputs)
});
export { toolcardupdated2 as "toolCardUpdated" }